import React from 'react';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import AddIcon from '@mui/icons-material/Add';
import { IMarketplaceFilterType } from 'src/components/profileComponents/Marketplace/types';
import { MarketplaceButton } from 'src/components/profileComponents/Marketplace/components/Common/MarketplaceButton';

interface IActionButtonsProps {
  buttons?: IMarketplaceFilterType[];
  onClick?: (type: IMarketplaceFilterType) => void
}

export const ActionButtons: React.FC<IActionButtonsProps> = ({ buttons, onClick }) => {
  return (
    <>
      {buttons && buttons.includes(IMarketplaceFilterType.GroupingFilter) && (
        <MarketplaceButton
          startIcon={<FmdGoodOutlinedIcon />}
          label="Location"
          onClick={() => onClick && onClick(IMarketplaceFilterType.GroupingFilter)}
        />
      ) }
      {buttons && buttons.includes(IMarketplaceFilterType.AllValuesTag) && (
        <MarketplaceButton
          startIcon={<LabelOutlinedIcon />}
          label="Tag (all values)"
          onClick={() => onClick && onClick(IMarketplaceFilterType.AllValuesTag)}
        />
      ) }
      {buttons && buttons.includes(IMarketplaceFilterType.SelectedValuesTag) && (
        <MarketplaceButton
          startIcon={<AddIcon />}
          label="Tag group (selected values)"
          onClick={() => onClick && onClick(IMarketplaceFilterType.SelectedValuesTag)}
        />
      ) }
      {buttons && buttons.includes(IMarketplaceFilterType.AllValuesCheckbox) && (
        <MarketplaceButton
          startIcon={<FmdGoodOutlinedIcon />}
          label="Checkbox (all values)"
          onClick={() => onClick && onClick(IMarketplaceFilterType.AllValuesCheckbox)}
        />
      ) }
      {buttons && buttons.includes(IMarketplaceFilterType.AllValuesRange) && (
        <MarketplaceButton
          startIcon={<FmdGoodOutlinedIcon />}
          label="Range"
          onClick={() => onClick && onClick(IMarketplaceFilterType.AllValuesRange)}
        />
      ) }
    </>
  );
};
